import React from "react";
import "./about.css";
import about from "../../Image/about/processing.jpg";
import Fade from "react-reveal/Fade";
import { FcSlrBackSide, FcWorkflow, FcShop } from "react-icons/fc";

const About = () => {
  return (
    <div className="container about-section" id="about">
      <div className="row">
        <Fade left>
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="about-image">
              <img src={about} alt="about_image" />
            </div>
          </div>
        </Fade>
        <Fade right>
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="about-details">
              <div className="about-title">
                <h5>About</h5>
                <span className="line"></span>
              </div>
              Value Seeds Limited is an indigenous Nigerian seed Company
              incorporated in September 14, 2009, focused on the production and
              distribution of high-quality field crops and vegetable seeds. We
              are a leading agricultural value chain solution provider,
              specializing in seed research, multiplication, processing and
              distribution.
              <div className="card-design">
                <div className="about-list-item">
                  <div className="about-details-icon">
                    <p>
                      <FcSlrBackSide size={50} />
                    </p>
                  </div>
                  <div>
                    <h6>Our Vision</h6>
                    <p>
                      To lead the transformation of the seed system in West
                      Africa
                    </p>
                  </div>
                </div>
              </div>
              <div className="card-design">
                <div className="about-list-item">
                  <div className="about-details-icon">
                    <p>
                      <FcWorkflow size={50} />
                    </p>
                  </div>
                  <div>
                    <h6>Our Mission</h6>
                    <p>
                      To continuously commercialize innovative agricultural seed
                      technologies that will increase farmers’ yields, enhance
                      nutrition and build livelihoods through expertise,
                      technology application and being a customer centric seed
                      company
                    </p>
                  </div>
                </div>
              </div>
              <div className="card-design">
                <div className="about-list-item">
                  <div className="about-details-icon">
                    <p>
                      <FcShop size={50} />
                    </p>
                  </div>
                  <div>
                    <h6>Our Core Values</h6>
                    <ul>
                      <li>Integrity</li>
                      <li>Accountability</li>
                      <li>Innovation</li>
                      <li>Professionalism</li>
                      <li>Resourcefulness</li>
                      <li>Value Addition</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default About;
